import React, { useEffect, useState } from 'react';
import "./CSS/Hero.css";
import { db } from "../firebase-config";
import { doc, getDoc } from "firebase/firestore";

const Hero = () => {
  const [heroBg, setHeroBg] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch hero background from single doc
        const bgDoc = await getDoc(doc(db, "hero-background", "main"));
        if (bgDoc.exists()) {
          setHeroBg(bgDoc.data().url || "");
        }
      } catch (error) {
        console.error("❌ Error fetching hero background:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <section
      className="hero-header position-relative d-flex align-items-center justify-content-center"
      style={heroBg ? { background: `url(${heroBg}) center center/cover no-repeat` } : undefined}
    >
      <div className="hero-overlay position-absolute w-100 h-100"></div>
      <div className="container py-5 position-relative z-2">
        <div className="row g-5 align-items-center mb-4">
          <div className="col-lg-6 text-light">
            <h1 className="display-4 fw-bold mb-3 hero-title" style={{ lineHeight: 1.15 }}>
              Nurturing <span className="text-accent phrase">Lives.</span>
              <br/>
              Inspiring <span className="text-accent phrase">Hope.</span>
              <br/>
              Transforming <span className="text-accent phrase">Future.</span>
            </h1>
            <h5 className="mb-4  hero-subtitle">
              NOURISHING PEOPLE, ENRICHING LIVES.
            </h5>

            <a href="/donate" className="btn btn-lg shadow hero-cta">
              DONATE
            </a>
          </div>
          <div className="col-lg-6">

          </div>
        </div>
        <div className="row g-4 hero-info-row">
          <div className="col-6 col-md-3">
            <div className="hero-info-card d-flex flex-column align-items-center p-3">
              <div className="icon-circle bg-accent mb-2"><i className="bi bi-heart-fill icon"></i></div>
              <span className="info-card-text">Serving Humanity</span>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="hero-info-card d-flex flex-column align-items-center p-3">
              <div className="icon-circle bg-accent mb-2"><i className="bi bi-people-fill icon"></i></div>
              <span className="info-card-text">Empowering Communities</span>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="hero-info-card d-flex flex-column align-items-center p-3">
              <div className="icon-circle bg-accent mb-2"><i className="bi bi-person-heart icon"></i></div>
              <span className="info-card-text">Empowering lives</span>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="hero-info-card d-flex flex-column align-items-center p-3">
              <div className="icon-circle bg-accent mb-2"><i className="bi bi-book-fill icon"></i></div>
              <span className="info-card-text">Spirit of giving</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
